/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 5/28/15.
 */
'use strict';
angular.module('prism-ui.components').directive('datePicker', function (moment, ServerInfoService) {

	return {
		restrict: 'E',
		controller: 'DatePickerController',
		templateUrl: 'components/visual/datePicker/datepicker-template.html',
		require: ['ngModel', 'datePicker'],
		scope: {disabled: '=', calBtnId: '=', timezoneOffsetMillis: '=?'},
		bindToController: {disabled: '=', calBtnId: '='},
		controllerAs: 'datePickerCtrl',
		link: function (scope, element, attrs, ctrls) {
            // Standard timezone == Daylight timezone - 1 hour
            // If server in daylight timezone (ex: June 1st) & passing Standard time (ex: Jan 3rd) to the server...
            //     Standard time = Jan 3, 00:00 - 1 hour
            //     aka: Standard time will be in the previous date. (Jan 2, 23:00)
            // To avoid this, consider server 3-hours ahead of what it actually is
            // In daylight time: Input daylight time => sends 3AM
            //                   Input standard time => sends 2AM
            // In Standard time: Input daylight time => sends 4AM
            //                   Input standard time => sends 3AM
            // 3 hours ahead also prevents date from sending the invalid 12AM - 1AM time when daylight time switches.
            // Should work in all timezones because there aren't any timezones that would roll-over to the next date.
            //     aka: There are no "UTC+21", "UTC+22", or "UTC+23" timezones
            var DAYLIGHT_SAVINGS_SERVER_TIMEZONE_OFFSET_MILLIS = 3 * 60 * 60 * 1000;

            var ngModelCtrl = ctrls[0];
			var datePickerCtrl = ctrls[1];

            function getTimezoneOffsetMillis(dateStr) {
                if (scope.timezoneOffsetMillis === 'SERVER') {
                    // Get offset from server
                    return -ServerInfoService.getServerTimezoneOffsetMillis() + DAYLIGHT_SAVINGS_SERVER_TIMEZONE_OFFSET_MILLIS;
                } else if (typeof(scope.timezoneOffsetMillis) === 'number') {
                    return scope.timezoneOffsetMillis;
                }
                // Default offset: Local time (With Daylight time-zone based on the input date)
                return 1000 * 60 * ((new Date(dateStr)).getTimezoneOffset());
            }

			datePickerCtrl.buttonId = datePickerCtrl.calBtnId || attrs.id;

			ngModelCtrl.$render = function () {
				datePickerCtrl.date = ngModelCtrl.$viewValue.date;
			};

			ngModelCtrl.$formatters.push(function (modelValue) {
				var date = modelValue;
				if (date && !(date instanceof Date)) {
					modelValue = moment.parseZone(modelValue).format('YYYY-MM-DD');
					date = moment(modelValue).toDate();
				}

				return {
					date: date
				};
			});

			ngModelCtrl.$parsers.push(function(viewValue) {
				return viewValue.date;
			});

            datePickerCtrl.dateChanged = function () {
                var ctrlDateString = moment.parseZone(datePickerCtrl.date).format('YYYY-MM-DD');
                var date = moment.utc(ctrlDateString).toDate();
                date.setUTCMilliseconds(getTimezoneOffsetMillis(ctrlDateString));
                ngModelCtrl.$setViewValue({date: date});
            };

			datePickerCtrl.onDateFieldClick = function (event) {
				event.target.select();
			};
		}
	};
});
